export class DownloadQuoteECO {
  Status: string;
  Validations: any;
  Exception: string;
  Errors: any;
}
